import { render, staticRenderFns } from "./BroadcastManagePage.vue?vue&type=template&id=0677ceee&scoped=true"
import script from "./BroadcastManagePage.vue?vue&type=script&lang=js"
export * from "./BroadcastManagePage.vue?vue&type=script&lang=js"
import style0 from "./BroadcastManagePage.vue?vue&type=style&index=0&id=0677ceee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0677ceee",
  null
  
)

export default component.exports